module.exports = __webpack_public_path__ + "static/media/scan-game.2877f15b.png";